import { SERVICES } from "./services.js";

const SERVICE_ROUTE_META = {
  "/desarrollo-corporativo": {
    extraClass: "detail-page--desarrollo-corporativo",
    meta: {
      es: {
        title: "Desarrollo corporativo | Magallanes",
        ogDescription: "M&A, alianzas estratégicas y desarrollo de ecosistemas para potenciar el crecimiento corporativo.",
      },
      en: {
        title: "Corporate Development | Magallanes",
        ogDescription: "M&A, strategic alliances and ecosystem development to drive corporate growth.",
      },
    },
  },
  "/acceso-capital": {
    meta: {
      es: {
        title: "Acceso a Capital | Magallanes",
        ogDescription: "Apoyo en captación de fondos, conexión con inversores y consolidación de capital para vehículos de inversión privada.",
      },
      en: {
        title: "Capital Access | Magallanes",
        ogDescription: "Support in fundraising, investor connections and capital consolidation for private investment vehicles.",
      },
    },
  },
  "/internacionalizacion": {
    meta: {
      es: {
        title: "Internacionalización | Magallanes",
        ogDescription: "Soft-landing, captación de inversión extranjera y facilitación de operaciones internacionales.",
      },
      en: {
        title: "Internationalization | Magallanes",
        ogDescription: "Soft-landing, foreign investment attraction and international operations facilitation.",
      },
    },
  },
  "/innovacion": {
    meta: {
      es: {
        title: "Innovación | Magallanes",
        ogDescription: "Marcos regulatorios experimentales y estrategias de innovación público-privada.",
      },
      en: {
        title: "Innovation | Magallanes",
        ogDescription: "Experimental regulatory frameworks and public-private innovation strategies.",
      },
    },
  },
  "/posicionamiento-estrategico": {
    meta: {
      es: {
        title: "Posicionamiento estratégico | Magallanes",
        ogDescription: "Narrativa institucional, gestión de stakeholders y comunicación estratégica orientada a objetivos.",
      },
      en: {
        title: "Strategic Positioning | Magallanes",
        ogDescription: "Institutional narrative, stakeholder management and goal-oriented strategic communication.",
      },
    },
  },
  "/otras-areas": {
    extraClass: "detail-page--otras-areas",
    meta: {
      es: {
        title: "Otras áreas | Magallanes",
        ogDescription: "Desarrollo estratégico en turismo, sostenibilidad y urbanismo.",
      },
      en: {
        title: "Other Areas | Magallanes",
        ogDescription: "Strategic development in tourism, sustainability and urban planning.",
      },
    },
  },
};

export const STATIC_ROUTE_CATALOG = [
  {
    canonical: "/",
    slugs: { es: "", en: "" },
    service: false,
    section: "growth",
    body: { className: "page page--home" },
    meta: {
      es: {
        title: "Magallanes",
        ogDescription: "Asesoramiento estratégico para empresas: desarrollo corporativo, acceso a capital, internacionalización, innovación y posicionamiento.",
      },
      en: {
        title: "Magallanes",
        ogDescription: "Strategic advisory for companies: corporate development, capital access, internationalization, innovation and positioning.",
      },
    },
  },
  {
    canonical: "/equipo",
    slugs: { es: "equipo", en: "team" },
    service: false,
    section: "team",
    body: { kind: "team" },
    meta: {
      es: {
        title: "Equipo | Magallanes",
        ogDescription: "Albert Castellanos, director de Magallanes Business Consulting. Trayectoria en gestión pública y estrategia económica.",
      },
      en: {
        title: "Team | Magallanes",
        ogDescription: "Albert Castellanos, director of Magallanes Business Consulting. Background in public management and economic strategy.",
      },
    },
  },
  {
    canonical: "/contacto",
    slugs: { es: "contacto", en: "contact" },
    service: false,
    section: "contact",
    body: { className: "page page--contact" },
    meta: {
      es: {
        title: "Contacto | Magallanes",
        ogDescription: "Contacta con Magallanes Business Consulting en Barcelona y Madrid.",
      },
      en: {
        title: "Contact | Magallanes",
        ogDescription: "Contact Magallanes Business Consulting in Barcelona and Madrid.",
      },
    },
  },
  {
    canonical: "/aviso-legal",
    slugs: { es: "aviso-legal", en: "legal-notice" },
    service: false,
    section: "legal",
    body: { className: "page page--legal" },
    meta: {
      es: { title: "Aviso Legal | Magallanes", ogDescription: "Aviso legal de Magallanes Business Consulting." },
      en: { title: "Legal Notice | Magallanes", ogDescription: "Legal notice of Magallanes Business Consulting." },
    },
  },
  {
    canonical: "/politica-de-privacidad",
    slugs: { es: "politica-de-privacidad", en: "privacy-policy" },
    service: false,
    section: "legal",
    body: { className: "page page--legal" },
    meta: {
      es: { title: "Política de Privacidad | Magallanes", ogDescription: "Política de privacidad de Magallanes Business Consulting." },
      en: { title: "Privacy Policy | Magallanes", ogDescription: "Privacy policy of Magallanes Business Consulting." },
    },
  },
  {
    canonical: "/politica-de-cookies",
    slugs: { es: "politica-de-cookies", en: "cookie-policy" },
    service: false,
    section: "legal",
    body: { className: "page page--legal" },
    meta: {
      es: { title: "Política de Cookies | Magallanes", ogDescription: "Política de cookies de Magallanes Business Consulting." },
      en: { title: "Cookie Policy | Magallanes", ogDescription: "Cookie policy of Magallanes Business Consulting." },
    },
  },
];

export const SERVICE_ROUTE_CATALOG = SERVICES.map((service) => {
  const routeMeta = SERVICE_ROUTE_META[service.path];
  if (!routeMeta) {
    throw new Error(`Missing route metadata for service ${service.path}`);
  }

  return {
    canonical: service.path,
    slugs: { es: service.href, en: service.hrefEn },
    service: true,
    section: "growth",
    extraClass: routeMeta.extraClass ?? "",
    meta: routeMeta.meta,
    serviceData: service,
  };
});

export const ROUTE_CATALOG = [
  STATIC_ROUTE_CATALOG[0],
  ...SERVICE_ROUTE_CATALOG,
  ...STATIC_ROUTE_CATALOG.slice(1),
];

export const ROUTE_CATALOG_BY_CANONICAL = new Map(
  ROUTE_CATALOG.map((route) => [route.canonical, route])
);

export function getRouteCatalogEntry(canonical) {
  return ROUTE_CATALOG_BY_CANONICAL.get(canonical) ?? null;
}
